import script from "./TeacherWrongQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeacherWrongQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./TeacherWrongQuestion.vue?vue&type=style&index=0&id=3d5fec40&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5fec40"]])

export default __exports__